document.addEventListener('DOMContentLoaded', () => {

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let cardSlider = document.querySelectorAll('.card-slider');
    if(cardSlider){
        cardSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                pagination: {
                    el: ".pagination-card",
                    clickable: true,
                },
                breakpoints: {
                    770: {
                        slidesPerView: 2,
                    },
                },
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-sli-next",
                    prevEl: ".sw-sli-prev",
                }
            });
        });
    }

    let slideBgSlider = document.querySelectorAll('.slide-bg-slider');
    if(slideBgSlider){
        slideBgSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-sli-next",
                    prevEl: ".sw-sli-prev",
                }
            });
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slider');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

});